import { ReadonlyDate } from '../typings/readonly-date'

/**
 * This method correctly handles varying month lengths & leap years
 */
export function addMonths(readonlyDate: ReadonlyDate, months: number): Date {
  const date = new Date(readonlyDate.valueOf())
  const d = date.getDate()
  date.setMonth(date.getMonth() + months)
  if (date.getDate() != d) {
    date.setDate(0)
  }
  return date
}

/**
 * This method correctly handles varying month lengths & leap years
 */
export function addYears(readonlyDate: ReadonlyDate, years: number): Date {
  const date = new Date(readonlyDate.valueOf())
  const d = date.getDate()
  date.setFullYear(date.getFullYear() + years)
  if (date.getDate() != d) {
    date.setDate(0)
  }
  return date
}
